(ns machtfit.startpage.core
  (:require [machtfit.app.routes :as routes]
            [machtfit.startpage.events :as events]
            [machtfit.translation :as translation]
            [re-frame.core :as rf]))

(defn set-messages! []
  (translation/set-messages!
   :en {"Dein Guthaben: " "Your balance: "
        "Meine Kurse" "My courses"
        "Zusatzleistungen" "Additional services"
        "Neu!" "New!"
        "Erstattungsantrag" "Request for reimbursement"
        "Hilfe" "Help"
        "Alle Angebote" "All Offers"
        "Von zu Hause aus" "From home"
        "Hallo " "Hello "
        "Montag" "Monday"
        "Dienstag" "Tuesday"
        "Mittwoch" "Wednesday"
        "Donnerstag" "Thursday"
        "Freitag" "Friday"
        "Samstag" "Saturday"
        "Sonntag" "Sunday"
        "Mo" "Mo"
        "Di" "Tu"
        "Mi" "We"
        "Do" "Th"
        "Fr" "Fr"
        "Sa" "Sa"
        "So" "Su"
        " um " " at "
        " Uhr" " o'clock"
        "Empfohlen" "Recommended"
        "Rabatt-Aktion von machtfit" "Discount campaign by machtfit"
        " von deinem Guthaben" " out of your balance"
        " machtfit-Preisvorteil" " machtfit price advantage"
        "Firmenangebot" "Company offer"
        "Präventionsangebot" "Prevention offer"
        "%d Plätze" "%d spots"
        "ein Platz" "one spot"
        "ausgebucht" "booked out"
        "Reise" "Trip"
        "Alle Termine" "All dates"
        "machtfit Themenübersicht" "machtfit topic overview"
        "Jetzt Artikel lesen" "Read article now"
        "Artikel lesen" "Read article"
        "Ein Angebot" "One offer"
        "%d Angebote" "%d offers"
        " in Ihren Favoriten" " in your favorites"
        " gefunden" " found"
        "sortieren nach" "sort by"
        "Empfehlung" "Recommendation"
        "Entfernung" "Distance"
        "Preis" "Price"
        "Kategorien" "Categories"
        "Umkreis: %d km" "Distance: %d km"
        "von zu Hause / Apps / online / Reisen" "from home / apps / online / trips"
        "In unserer Rubrik " "In our section "
        "Gesundheitsreisen" "Health trips"
        "Umkreisfilter" "Distance filter"
        "Umkreis" "Distance"
        " Angebote im Umkreis von %d km" " offers within a distance of %d km"
        "im Umkreis vom Arbeitsort" "around your place of work"
        "im Umkreis vom Wohnort" "around your place of residence"
        "Wohnort nicht hinterlegt! " "No place of residence given! "
        "Jetzt Wohnort angeben" "Enter your place of residence now"
        "weitere Optionen" "additional options"
        "Angebote anzeigen" "Show offers"
        "Eigenschaften" "Properties"
        "mit Arbeitgeberzuschuss" "with employer's allowance"
        "mit Guthabenzuschuss" "covered by my balance"
        "-Preisvorteil" "-price advantage"
        "Favoriten (" "Favorites ("
        "Rechtliches" "Legal issues"
        "Sprachen" "Languages"
        "In einer Entfernung von %d km haben wir jedoch " "However, at a distance of %d km we have "
        "ein passendes Angebot für dich!" "one suitable offer for you!"
        "%d passende Angebote für dich!" "%d suitable offers for you!"
        "Umkreis auf %d km erweitern" "Extend distance to %d km"
        "Jetzt Angebote ansehen" "View offers now"
        "Nutze unsere automatische Erinnerungsfunktion: " "Use our automatic reminder function: "
        "hier" "here"
        " deine Wunschkategorien mit." " your desired categories."
        "Trainingspläne" "Training schedules"
        "Fitness- und Ernährungsbasics" "Fitness and nutrition basics"
        "Rezepte" "Recipes"
        "Oops... Etwas ist schief gelaufen!" "Oops... Something went wrong!"
        "Plattform neu laden" "Reload platform"
        "Laden..." "Loading..."
        "Favoriten" "Favorites"
        "Bewegung" "Exercise"
        "Ernährung" "Nutrition"
        "Gesundheit" "Healthy living"
        "Entspannung" "Relaxation"
        "Online-Angebote" "Online offerings"
        "Wohlbefinden" "Well-being"
        "Mitgliedschaft" "Membership"
        "Reisen" "Trips"
        "Fit fühlen" "Stay fit"
        "Entspannung finden" "Relax"
        "Passend für dich" "Suitable for you"
        "Gesund essen" "Eat healthy"
        "Angebote mit machtfit Preisvorteil" "Offers with machtfit price advantage"
        "Beliebte Angebote" "Popular offers"
        "Neue Artikel im Magazin" "Latest posts from our magazine"
        "Neu eingetroffen" "Published recently"
        "Exklusiv bei machtfit" "Exclusive at machtfit"
        "Fitnessprodukte" "Fitness products"
        "Präventionsangebote" "Prevention offer"
        "Angebote zur Prävention" "Preventive offers"
        "Wieder geöffnet" "Open again"

        "Vielleicht findest du ja eine Anregung in unserem Magazin."
        "Perhaps you will find a suggestion in our magazine."

        "Wähle einen Umkreis aus, um die Angebots-Vorschau zu erhalten."
        "Select a distance to get the offer preview."

        "Leider konnten wir kein passendes Angebot in deiner Nähe finden."
        "Unfortunately, we could not find a suitable offer close to you."

        " haben wir jedoch %d passende Angebote, die deinen Suchkriterien entsprechen."
        " however, we have %d suitable offers, which correspond to your search criteria."

        "Wenn ein Angebot deiner Wahl in deiner Nähe veröffentlicht wird, erhälst du vorab eine Information per E-Mail und kannst das Angebot buchen. Teile uns "
        "When an offer of your choice is published near you, you will receive information in advance by email and can book the offer. Tell us "

        "Von A wie Aquafitness bis Z wie Zumba: Starte durch mit unseren Bewegungskursen. Zum Auspowern, Fitbleiben und Spaßhaben! Tipps vom Fitnesscoach, Trainingspläne und vieles mehr liest du in unseren Beiträgen."
        "From A like aqua fitness to Z like Zumba: Get started with our exercise classes. Push yourself, stay fit and have fun! Find tips from fitness coaches, training plans and much more in our posts."

        "Eine gesunde, abwechslungsreiche Ernährung ist ein wichtiger Schlüssel zum Wohlbefinden. Nur: Im stressigen Arbeitsleben ist das gar nicht immer so einfach. Unsere Kurse, Tipps und Rezepte zeigen dir die besten Wege aus der „Currywurst-Falle“."
        "A healthy, diverse diet is an important key to well-being. Unfortunately it's not always that easy in a stressful working life. Our courses, tips and recipes will show you the best ways out of the \"currywurst trap\"."

        "Sich selbst und seinem Körper etwas Gutes tun: Dazu gibt es viele Möglichkeiten. Wie du gute Vorsätze in die Tat umsetzt, erfährst du in unseren Beiträgen – und noch besser live in unseren Gesundheitskursen."
        "There are many ways to do something good for yourself and your body. How to put good intentions into action is explained in our articles - and even better in our health courses."

        "Der Alltag fordert dir viel ab? Mit den richtigen Entspannungstechniken und Anti-Stress-Strategien bleibst du relaxt und leistungsfähig. Unsere Beiträge erklären, wie's geht – oder buche gleich den passenden Kurs."
        "Everyday life demands a lot from you? With the right relaxation and anti-stress strategies you can stay relaxed and efficient. Our articles explain how it works - or you can book the right course right away."

        "%d Mitglied" "%d Member"
        "%d Mitglieder" "%d Members"

        "Du bist Zuschauer" "You are a spectator"

        "%d Tag" "%d day"
        "%d Tage" "%d days"
        "%d Tagen" "%d days"
        "%d Stunde" "%d hour"
        "%d Stunden" "%d hours"
        "%d Minute" "%d minute"
        "%d Minuten" "%d minutes"
        "und" "and"

        "Noch {countdown} bis zum Start {the-challenge-genitive}." "Only {countdown} left until {the-challenge} starts."

        "{The-challenge} läuft bereits. Du hast noch {countdown} Zeit um einem Team beizutreten." "{The-challenge} is already underway. You have {countdown} left to join a team."

        "Der Anmeldezeitraum ist leider vorbei. Du kannst {the-challenge-accusative} nun als Zuschauer verfolgen." "Unfortunately the registration period is over. You can still follow {the-challenge-accusative} as a spectator."

        "{The-challenge} endet in {countdown-dative}." "{The-challenge} ends in {countdown-dative}."

        "{The-challenge} ist beendet. Du kannst noch {countdown} deine {main-units} der letzten Tage eintragen." "{The-challenge} is over. You still have {countdown} left to track the {main-units} of the last days."

        "{The-challenge} ist vorbei." "{The-challenge} is over."
        "{The-challenge} ist vorbei. Wir freuen uns über Feedback." "{The-challenge} is over. We would love some feedback!"

        "Feedback geben" "Send feedback"

        "Möchtest du mitmachen?" "You want to participate?"
        "Wähle jetzt dein Team." "Join a team!"

        "Neues Team gründen" "Create a new team"
        "noch keine Mitglieder" "no members yet"

        "Team beitreten" "Join team"

        "zurück" "back"

        "Gib deinem Team einen Namen damit andere Teilnehmer es finden können." "Give your team a name so other participants can find it."

        "Teamname" "Team name"

        "Erlaube optional neue Teammitglieder nur mit Zugangscode." "Optionally require an access code to join the team."
        "ohne Zugangscode" "without access code"

        "mit Zugangscode" "with access code"

        "Team {team-name} gründen" "Create team {team-name}"

        "Mitglieder" "Members"

        "Dein Name im Team" "Your name in the team"

        "Dein Name ist sichtbar für andere Teilnehmer." "Your name is visible to other participants."

        "Name ungültig" "Invalid name"

        "Teamname ungültig" "Invalid team name"

        "Zugangscode ungültig" "Invalid access code"
        "Zugangscode falsch" "Wrong access code"

        "Name bereits vergeben" "Name is already taken"

        "Dieser Teamname ist bereits vergeben." "This team name is already taken."

        "{member-count} Mitglied werden" "Become the {member-count} member"

        "Zugangscode" "Access code"
        "Frag ein Teammitglied nach dem Zugangscode." "Ask a team member for the access code."

        "Team gegründet" "Created team"

        [:p "Herzlichen Glückwunsch! Du hast das Team " [:b [:q "{team-name}"]] " mit dem Zugangscode " [:b [:q "{access-code}"]] " gegründet. Kolleg:innen können ihm jetzt beitreten. Lade sie am besten gleich ein! Wir wünschen dir viel Spaß!"]
        [:p "Congratulations! You created the team " [:b [:q "{team-name}"]] " with the access code " [:b [:q "{access-code}"]] ". Coworkers can now join. Invite them now. Have fun walking!"]

        [:p "Herzlichen Glückwunsch! Du hast das Team " [:b [:q "{team-name}"]] " gegründet. Kolleg:innen können ihm jetzt beitreten. Lade sie am besten gleich ein! Wir wünschen dir viel Spaß!"]
        [:p "Congratulations! You created the team " [:b [:q "{team-name}"]] ". Coworkers can now join. Invite them now. Have fun walking!"]

        "Los geht's!" "Let’s go!"

        [:p "Herzlichen Glückwunsch! Du bist jetzt im Team " [:b [:q "{team-name}"]] ". Lade am besten gleich weitere Kolleg:innen ein. Wir wünschen dir viel Spaß!"]
        [:p "Congratulations! You are now a member of the team " [:b [:q "{team-name}"]] ". Invite more coworkers to join! Have fun walking!"]

        "Willkommen im Team!" "Welcome to the team!"

        "%s Schritt" "%s step"
        "%s Schritte" "%s steps"

        "am " "on "
        "bis zum " "until "

        "Meine Schritte" "My steps"
        "Mein Team" "My team"

        "Mitglieder (%d)" "Members (%d)"
        "Platz" "Rank"
        "Schritte pro Tag" "Steps per day"
        "Schritte gesamt" "Steps total"

        "Team verlassen?" "Leave your team?"
        "Möchtest du dein Team {team-name} wirklich verlassen? Bereits erfasste {main-units} werden in ein neues Team mitgenommen. Du hast noch {countdown} Zeit, einem neuen Team beizutreten."
        "If you leave {team-name} {main-units} that have already been entered will be moved with you to a new team. You have {countdown} to join an other team."

        "Team verlassen" "Leave team now"

        "Wertung beenden?" "Exit scoring?"
        "Wenn du deine Wertung beendest, gehen dieser und alle folgenden Tage nicht in die Team-Wertung und die Gesamtbewertung mit ein."
        "Exiting your scoring will enter effect in 24 hours. After that, your steps will not be included in the team and competition scores."

        "Doch nicht" "Nevermind"
        "Wertung beenden" "Exit scoring"

        "Wertung doch nicht beenden" "Don't exit team score"
        "Wenn du deine Wertung beendest, kannst du dies 24 Stunden lang rückgängig machen. Danach unterstützt du dein Team nicht mehr."
        "If you exit your scoring, after 24 hours you won’t be able to resume counting steps again. However, you will stay in the team."

        "Du hast noch {countdown}, um doch in der Wertung zu bleiben. Andernfalls unterstützt du dein Team nicht weiter." "You have {countdown} to resume your scoring. Afterwards, your steps won’t count in the competition anymore."

        "Möchtest du dein Team verlassen? Du kannst einem neuen Team beitreten oder Zuschauer werden."
        "Leaving your team means that you will abandon the competition. You can join another team or become a spectator."

        "Bestenliste" "Leaderboard"

        "Zieleinlauf am: " "Finished on "

        "Heute" "today"
        "Gesamt" "all"

        "Start" "Start"
        "Ende" "End"
        "Tagesziel" "Daily goal"
        "Wertung beendet" "Scoring exited"

        "Aktivität hinzufügen" "Add activity"

        "Schritte" "steps"
        "Schritte im Schnitt" "average steps"
        "Insgesamt gelaufen:" "Total number of steps:"
        "Teamfortschritt:" "Team progress:"

        "Hast du Schritte gezählt und möchtest diese hinzufügen?" "Do you want to add steps you’ve counted?"
        "Möchtest du eine andere Aktivität hinzufügen?" "Do you want to add other activities?"
        "Welche Aktivität möchtest du hinzufügen?" "Which activity do you want to add?"

        "Wieviele {main-units} möchtest du hinzufügen?" "How many {main-units} do you want to add?"

        "Schritte für " "Steps for "

        "Du hast noch {countdown} um {main-units} für {weekday} hinzuzufügen." "You still have {countdown} to add {main-units} for {weekday}."

        "Die 3-Tage-Fair-Play Regel setzt nach Mitternacht ein." "The three-day fair play rule will be effective after midnight."

        "Wieviele {unit-name} möchtest du für die Aktivität {activity} eintragen?" "How many {unit-name} do you want to add for {activity}?"

        "Es tut uns Leid!" "We are sorry."

        "Deine {main-units} für {weekday} ({date}) werden nicht mitgezählt, weil die Frist für das Eintragen der {main-units} abgelaufen ist." "Your {main-units} were not counted for {weekday} ({date}) as the deadline to enter {main-units} for this day has expired."

        "Weiter" "Continue"

        "Das war so knapp." "That was close."

        "Deine {main-units} für {weekday} ({date}) werden nicht mitgezählt, da sie erst nach 0 Uhr  eingegangen sind." "Your {main-units} were not counted for {weekday} ({date}). They reached us after midnight."

        "Es tut uns Leid, die Frist für die 3-Tage-Fair-Play-Regel ist abgelaufen." "We're sorry, the deadline of the three-day fair play rule was met."

        "Mit dem Eintreten in dieses Team stimmst du den Teilnahmebedingungen des Wettbewerbs zu. Diese kannst du in unserer Hilfe nachlesen."
        "By entering this team, you agree to the terms and conditions of the competition. You can read this in the help area."

        "Datenschutzhinweis" "Data privacy statement"}))

(defn ^:export load [js-data]
  (set-messages!)
  (rf/dispatch-sync [::events/init (js->clj js-data :keywordize-keys true)])
  (rf/dispatch-sync [::routes/routing routes/router {:boot? true}]))
